import React from 'react';

import { useAuth } from 'contexts/AuthContext';
import {
  Navigate,
  useLocation,
} from 'react-router-dom';

type Props = {
  reroutePath: string;
  element: JSX.Element;
};

export const RequireUser = ({ reroutePath, element }: Props) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) {
    // Redirect the user to the provided route, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page in the future.
    return <Navigate to={reroutePath} state={{ from: location }} replace />;
  }

  return element;
};
